import React from 'react';

import GridAxis from './D3GridAxis';

const D3ChartGrid = ({
  chartId,
  clipPathId,
  height,
  width,
  xScale,
  yScale,
  xTickValues,
  yTickValues,
  xTicks,
  yTicks,
  verticalGridOffset = 0,
  hideHorizontal = false,
  hideVertical = false,
}) => {
  const xSettings = {
    id: `${chartId}-x-grid`,
    scale: xScale,
    orient: 'bottom',
    transform: `translate(${verticalGridOffset}, ${height})`,
    ticks: xTicks,
    tickSize: -height,
    tickValues: xTickValues,
  };
  const ySettings = {
    id: `${chartId}-y-grid`,
    scale: yScale,
    orient: 'left',
    transform: 'translate(0, 0)',
    tickSize: -width,
    ticks: yTicks,
    tickValues: yTickValues,
  };
  return (
    <g className="grid-group" clipPath={`url(#${clipPathId})`}>
      {
        !hideVertical && (
          <GridAxis {...xSettings} />
        )
      }
      {
        !hideHorizontal && (
          <GridAxis {...ySettings} />
        )
      }
    </g>
  );
};

export default D3ChartGrid;
